module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('el-row', {
    staticClass: "containRow"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("\n        当前有\n        "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(this.arrlength))]), _vm._v("人等候\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "color",
    on: {
      "click": _vm.inquiryLi
    }
  }, [_c('i', {
    staticClass: "fa fa-retweet"
  }), _vm._v("\n        切换看诊人\n      ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n      紧急程度：\n      "), [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.medicine
    },
    model: {
      value: (_vm.situation),
      callback: function($$v) {
        _vm.situation = $$v
      },
      expression: "situation"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)]], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticClass: "finishDoctor",
    staticStyle: {
      "background-color": "#3C6EA9",
      "color": "#fff",
      "border-radius": "10px"
    },
    on: {
      "click": _vm.finishDoctor
    }
  }, [_vm._v("结束看诊")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "in-content"
  }, [_c('el-row', {
    staticClass: "containRow",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple Info"
  }, [_c('div', {
    staticClass: "in-con"
  }, [_c('img', {
    staticClass: "doctorImg",
    attrs: {
      "src": _vm.info.img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "in-file"
  }, [_c('span', [_vm._v(_vm._s(_vm.info.name))])]), _vm._v(" "), _c('div', {
    staticClass: "in-table"
  }, [_c('div', {
    staticClass: "in-tabOne"
  }, [_c('h2', [_vm._v("\n                  性别:\n                  "), _c('span', [_vm._v(_vm._s(_vm.info.sex))])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tabTwo"
  }, [_c('h2', [_vm._v("\n                  周岁:\n                  "), _c('span', [_vm._v(_vm._s(_vm.info.age))])])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tel"
  }, [_c('h2', [_vm._v("\n                电话:\n                "), _c('span', [_vm._v(_vm._s(_vm.info.tel))])])])]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "800",
      "trigger": "click"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "line-height": "50px"
    }
  }, [_vm._v("历史病例：")])]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.collapseData), function(items, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": items.inquiryDate + ' ' + items.diagnosisType + ' ' + items.patientName,
        "name": index + 1
      }
    }, [(items.medicalRecordResponse) ? _c('span', {
      staticClass: "subheading"
    }, [_c('div', {
      staticClass: "accordionTitle"
    }, [_vm._v("病例")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("主诉:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.mainSuit) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("现病史:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.hpi) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("既往辅助检查:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.assistantExamination) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("刻下:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.kexia) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("舌苔:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.shetai) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("脉象:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.pulseCondition) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("西医:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.wDiagnosisResult) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("病症名:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.mDiseasesZh) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("英文病症名:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.mDiseasesEn) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("症型:")]), _vm._v("\n                    " + _vm._s(items.medicalRecordResponse.mDiagnosisResult) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (items.recipeResponse) ? _c('span', {
      staticClass: "subheading"
    }, [_c('div', {
      staticClass: "accordionTitle"
    }, [_vm._v("中药汤方")]), _vm._v(" "), (items.recipeResponse.recipeItemResponses) ? _c('span', _vm._l((items.recipeResponse.recipeItemResponses), function(citem, inx) {
      return _c('div', {
        key: inx,
        staticClass: "traditional"
      }, [_c('span', [_vm._v("药品:")]), _vm._v("\n                      " + _vm._s(citem.value) + " - " + _vm._s(citem.number) + _vm._s(citem.unit) + "\n                    ")])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', [_c('span', [_vm._v("副数:")]), _vm._v("\n                    " + _vm._s(items.recipeResponse.quantity) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("煎服法:")]), _vm._v("\n                    " + _vm._s(items.recipeResponse.eatType) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("忌口及日常护理:")]), _vm._v("\n                    " + _vm._s(items.recipeResponse.note) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (items.otherCheckRecordResponse) ? _c('span', {
      staticClass: "subheading"
    }, [_c('div', {
      staticClass: "accordionTitle"
    }, [_vm._v("辅助检查")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("项目名称:")]), _vm._v("\n                    " + _vm._s(items.otherCheckRecordResponse.checkedName) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (items.recipeResponses) ? _c('span', {
      staticClass: "subheading"
    }, [_c('div', {
      staticClass: "accordionTitle"
    }, [_vm._v("汤方信息")]), _vm._v(" "), _vm._l((items.recipeResponses), function(cell, index) {
      return _c('div', {
        key: index
      }, [_c('div', [_c('h3', [_vm._v(_vm._s(cell.recipeName))])]), _vm._v(" "), _vm._l((cell.recipeItemResponses), function(dall, index) {
        return _c('span', {
          key: index
        }, [_c('span', {
          staticStyle: {
            "color": "darkorange"
          }
        }, [_c('span', [_vm._v(_vm._s(dall.value))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(dall.number) + _vm._s(dall.unit))])]), _vm._v(" "), _c('span', {
          staticStyle: {
            "padding": "0 10px"
          }
        }, [_vm._v("/")])])
      })], 2)
    })], 2) : _vm._e()])
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "30px",
      "border-radius": "10px",
      "background-color": "#3C6EA9"
    },
    attrs: {
      "slot": "reference",
      "type": "primary",
      "icon": "el-icon-tickets"
    },
    slot: "reference"
  }, [_vm._v("历史病历")])], 1), _vm._v(" "), _c('div', {
    staticClass: "in-con in-conThree"
  }, [_c('div', {
    staticClass: "in-past"
  }, [_c('h2', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("家族史")]), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#39C0E1",
      "color": "#fff"
    },
    attrs: {
      "icon": "el-icon-plus",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.addOneRow('familyHistory')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteOneRow('familyHistory')
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.all_sides.familyHistory), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "in-disease"
    }, [_c('el-input', {
      staticStyle: {
        "padding-top": "10px"
      },
      attrs: {
        "value": item,
        "type": "textarea",
        "autosize": "",
        "placeholder": "请输入内容"
      },
      on: {
        "change": function($event) {
          return _vm.changeOneRow($event, index, 'familyHistory')
        }
      },
      model: {
        value: (_vm.all_sides.familyHistory[index]),
        callback: function($$v) {
          _vm.$set(_vm.all_sides.familyHistory, index, $$v)
        },
        expression: "all_sides.familyHistory[index]"
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "in-con in-conThree"
  }, [_c('div', {
    staticClass: "in-past"
  }, [_c('h2', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("过往病史及过敏史")]), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#39C0E1",
      "color": "#fff"
    },
    attrs: {
      "icon": "el-icon-plus",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.addOneRow('allergicHistory')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteOneRow('allergicHistory')
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.all_sides.allergicHistory), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "in-disease"
    }, [_c('el-input', {
      staticStyle: {
        "padding-top": "10px"
      },
      attrs: {
        "type": "textarea",
        "value": item,
        "autosize": "",
        "placeholder": "请输入内容"
      },
      on: {
        "change": function($event) {
          return _vm.changeOneRow($event, index, 'allergicHistory')
        }
      },
      model: {
        value: (_vm.all_sides.allergicHistory[index]),
        callback: function($$v) {
          _vm.$set(_vm.all_sides.allergicHistory, index, $$v)
        },
        expression: "all_sides.allergicHistory[index]"
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.info.sex == '女') ? _c('div', {
    staticClass: "in-con in-conThree"
  }, [_c('div', {
    staticClass: "in-past"
  }, [_c('h2', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("月经史，绝经期，孕产史")]), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#39C0E1",
      "color": "#fff"
    },
    attrs: {
      "icon": "el-icon-plus",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.addOneRow('menstrual')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteOneRow('menstrual')
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.all_sides.menstrual), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "in-disease"
    }, [_c('el-input', {
      staticStyle: {
        "padding-top": "10px"
      },
      attrs: {
        "type": "textarea",
        "value": item,
        "autosize": "",
        "placeholder": "请输入内容"
      },
      on: {
        "change": function($event) {
          return _vm.changeOneRow($event, index, 'menstrual')
        }
      },
      model: {
        value: (_vm.all_sides.menstrual[index]),
        callback: function($$v) {
          _vm.$set(_vm.all_sides.menstrual, index, $$v)
        },
        expression: "all_sides.menstrual[index]"
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "in-con in-conThree"
  }, [_c('div', {
    staticClass: "in-past"
  }, [_c('h2', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("生活偏嗜")]), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#39C0E1",
      "color": "#fff"
    },
    attrs: {
      "icon": "el-icon-plus",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.addOneRow('lifePartialAddicted')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteOneRow('lifePartialAddicted')
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.all_sides.lifePartialAddicted), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "in-disease"
    }, [_c('el-input', {
      staticStyle: {
        "padding-top": "10px"
      },
      attrs: {
        "type": "textarea",
        "value": item,
        "autosize": "",
        "placeholder": "请输入内容"
      },
      on: {
        "change": function($event) {
          return _vm.changeOneRow($event, index, 'lifePartialAddicted')
        }
      },
      model: {
        value: (_vm.all_sides.lifePartialAddicted[index]),
        callback: function($$v) {
          _vm.$set(_vm.all_sides.lifePartialAddicted, index, $$v)
        },
        expression: "all_sides.lifePartialAddicted[index]"
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "in-con in-conThree"
  }, [_c('div', {
    staticClass: "in-past"
  }, [_c('h2', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("病因病机")]), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#39C0E1",
      "color": "#fff"
    },
    attrs: {
      "icon": "el-icon-plus",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.addOneRow('pathogenyAndPathology')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteOneRow('pathogenyAndPathology')
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.all_sides.pathogenyAndPathology), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "in-disease"
    }, [_c('el-input', {
      staticStyle: {
        "padding-top": "10px"
      },
      attrs: {
        "type": "textarea",
        "value": item,
        "autosize": "",
        "placeholder": "请输入内容"
      },
      on: {
        "change": function($event) {
          return _vm.changeOneRow($event, index, 'pathogenyAndPathology')
        }
      },
      model: {
        value: (_vm.all_sides.pathogenyAndPathology[index]),
        callback: function($$v) {
          _vm.$set(_vm.all_sides.pathogenyAndPathology, index, $$v)
        },
        expression: "all_sides.pathogenyAndPathology[index]"
      }
    })], 1)
  })], 2), _vm._v(" "), (false) ? _c('div', {
    staticClass: "in-con in-conThree"
  }, [_c('div', {
    staticClass: "in-past"
  }, [_c('h2', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("侧边信息字段A")]), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#39C0E1",
      "color": "#fff"
    },
    attrs: {
      "icon": "el-icon-plus",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.addOneRow('sideInformationA')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteOneRow('sideInformationA')
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.all_sides.sideInformationA), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "in-disease"
    }, [_c('el-input', {
      staticStyle: {
        "padding-top": "10px"
      },
      attrs: {
        "type": "textarea",
        "value": item,
        "autosize": "",
        "placeholder": "请输入内容"
      },
      on: {
        "change": function($event) {
          return _vm.changeOneRow($event, index, 'sideInformationA')
        }
      },
      model: {
        value: (_vm.all_sides.sideInformationA[index]),
        callback: function($$v) {
          _vm.$set(_vm.all_sides.sideInformationA, index, $$v)
        },
        expression: "all_sides.sideInformationA[index]"
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "in-con in-conThree"
  }, [_c('div', {
    staticClass: "in-past"
  }, [_c('h2', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("病毒携带史")]), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#39C0E1",
      "color": "#fff"
    },
    attrs: {
      "icon": "el-icon-plus",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.dialogTableVisible = true)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "data": _vm.gridData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "virus",
      "label": "病毒类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "year",
      "label": "持续时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "approach",
      "label": "感染途径"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row, _vm.gridData)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "35%",
      "visible": _vm.dialogFormVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "病毒携带史:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.virus),
      callback: function($$v) {
        _vm.virus = $$v
      },
      expression: "virus"
    }
  }, _vm._l((_vm.virusCarry), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "持续时间 - 年:",
      "label-width": _vm.formLabelWidth
    }
  }, [
    [_c('el-input-number', {
      attrs: {
        "precision": 1,
        "step": 0.1,
        "min": 0.1
      },
      model: {
        value: (_vm.year),
        callback: function($$v) {
          _vm.year = $$v
        },
        expression: "year"
      }
    })]
  ], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "感染途径:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入内容"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.approach),
      callback: function($$v) {
        _vm.approach = $$v
      },
      expression: "approach"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSave(_vm.dialogFormVisible = false)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增病毒携带史",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "病毒携带史:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.virus),
      callback: function($$v) {
        _vm.virus = $$v
      },
      expression: "virus"
    }
  }, _vm._l((_vm.virusCarry), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "持续时间 - 年:",
      "label-width": _vm.formLabelWidth
    }
  }, [
    [_c('el-input-number', {
      attrs: {
        "precision": 1,
        "step": 0.1,
        "min": 0.1
      },
      model: {
        value: (_vm.year),
        callback: function($$v) {
          _vm.year = $$v
        },
        expression: "year"
      }
    })]
  ], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "感染途径:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入内容"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.approach),
      callback: function($$v) {
        _vm.approach = $$v
      },
      expression: "approach"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addbingdu(_vm.dialogTableVisible = false)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveUserHistory
    }
  }, [_vm._v("立即修改侧边病史")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple Info"
  }, [_c('inquiryone', {
    ref: "c1",
    attrs: {
      "timeDate": _vm.timeDate
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-582348a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/inquiry/inquiry.vue
// module id = 1021
// module chunks = 2